import { PAGE_HEADER_IMG_URL_DESKTOP, PAGE_HEADER_IMG_URL_MOBILE } from '../../../core/config';
import { useMaxViewport } from '../../../core/hooks/use-max-viewport';

export const useKeyVisual = (): string => {
  const isMobile = useMaxViewport('s');

  return isMobile ? PAGE_HEADER_IMG_URL_MOBILE : PAGE_HEADER_IMG_URL_DESKTOP;
};
